export default __webpack_public_path__ + "static/faqBg-5e0755be0e1953e9532aa15ec835c659.png";